export enum DrawerContent {
    Bible = "Bible",
    Sermon = "Sermons",
    Illustration = "Illustrations",
    Details = "Details",
    Slides = "Slides",
    Genius = "Sermon Genius",
    Analyzer = "Sermon Analyzer",
    Assistant = "AI Assistant",
}

export function toDrawerContent(drawerContentValue: string)
{
    switch(drawerContentValue){
        case "Bible": return DrawerContent.Bible; 
        case "Sermons": return DrawerContent.Sermon; 
        case "Illustrations": return DrawerContent.Illustration; 
        case "Details": return DrawerContent.Details; 
        case "Slides": return DrawerContent.Slides; 
        case "Sermon Genius": return DrawerContent.Genius;
        case "Sermon Analyzer": return DrawerContent.Analyzer;
        case "AI Assistant": return DrawerContent.Assistant;
        default: return DrawerContent.Bible;
    }
}